<template>
  <div>
    <!-- تصویر کوچک (تامنیل) -->
    <div @click="dialog = true" style="cursor: pointer; display: inline-block;">
      <v-img
          v-if="imageUrl"
        :src="imageUrl"
        width="60"
        height="60"
        class="rounded"
      >
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </v-row>
        </template>
      </v-img>
       <span v-else class="grey--text">ندارد</span>
    </div>

    <!-- پاپ‌آپ نمایش تصویر بزرگ -->
       <custom-popup
v-model="dialog"    max-width="900px"
    :cons="cons"
    hide-confirm
  >
    <v-card flat class="rounded-xl overflow-hidden pa-8">        
        <v-card-text class="pa-4 text-center">
          <v-img 
            :src="imageUrl" 
            max-height="70vh" 
            contain
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-card-text>
      </v-card>
    </custom-popup>
  </div>
</template>

<script>
export default {
  name: "ImageThumbnail",
  props: ['data', 'value'],
  data() {
    return {
      dialog: false,
            cons: {
        title: "فیش/سند",
        buttons: [],
        icon: "",
      },

    };
  },
  computed: {
    imageUrl() {
      return this.value || this.data?.data?.image || this.data?.image ;
    }
  }
}
</script>













